import { render, staticRenderFns } from "./SupplierContactPeople.vue?vue&type=template&id=40e4c24c&scoped=true"
import script from "./SupplierContactPeople.vue?vue&type=script&lang=js"
export * from "./SupplierContactPeople.vue?vue&type=script&lang=js"
import style0 from "./SupplierContactPeople.vue?vue&type=style&index=0&id=40e4c24c&prod&lang=scss&scoped=true"
import style1 from "./SupplierContactPeople.vue?vue&type=style&index=1&id=40e4c24c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e4c24c",
  null
  
)

export default component.exports